export default "{\n    \"label\": \"Role\"\n}\n"